import { apiDelete, apiGet, apiPost, apiPut } from './api-service';

const path = 'incident/type';

export interface Question {
    id?: string;
    question: string;
    required?: boolean;
}

export interface Document {
    id?: string;
    s3_key: string;
    name: string;
}

export interface IncidentType {
    id: string;
    name: string;
    description: string;
    created_at: string;
    updated_at: string;
    deleted_at: string | null;
    questions: Question[];
    documents: Document[];
}

export async function getIncidentTypes() {
    const response = await apiGet('core', path);
    return response;
}

export async function getIncidentType(id: string) {
    const response = await apiGet('core', `${path}/${id}`);
    return response;
}

export async function createIncidentType(data: Partial<IncidentType>) {
    const response = await apiPost('core', path, data);
    return response;
}

export async function updateIncidentType(id: string, data: Partial<IncidentType>) {
    const response = await apiPut('core', `${path}/${id}`, data);
    return response;
}

export async function removeIncidentType(id: string) {
    const response = await apiDelete('core', `${path}/${id}`);
    return response;
}
